var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { query } from 'lit/decorators.js';
import { sdsCustomElement } from '../utilities/custom-components';
import { SdsTdBase } from './_sds-td-base';
import styles from './sds-th.lit.scss';
/**
 * Control represents data cell that is a header.
 *
 * @tag sds-th
 */
let SdsTh = (() => {
    var _SdsTh_containerAnchor_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-th')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTdBase;
    let _containerAnchor_decorators;
    let _containerAnchor_initializers = [];
    let _containerAnchor_extraInitializers = [];
    var SdsTh = _classThis = class extends _classSuper {
        get containerAnchor() { return __classPrivateFieldGet(this, _SdsTh_containerAnchor_accessor_storage, "f"); }
        set containerAnchor(value) { __classPrivateFieldSet(this, _SdsTh_containerAnchor_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-th" part="sds-th" name="td-container">
                <slot name="checkbox"></slot>
                <div class="sds-th">
                    ${this.renderText()}
                    <slot name="icon"></slot>
                </div>
                <slot name="sorting"></slot>
            </div>
        `;
        }
        getTextContainer() {
            return this.containerAnchor;
        }
        renderText() {
            if (this.value) {
                return html ` ${this.value} `;
            }
        }
        constructor() {
            super(...arguments);
            _SdsTh_containerAnchor_accessor_storage.set(this, __runInitializers(this, _containerAnchor_initializers, void 0));
            __runInitializers(this, _containerAnchor_extraInitializers);
        }
    };
    _SdsTh_containerAnchor_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTh");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _containerAnchor_decorators = [query('div[name="td-container"]')];
        __esDecorate(_classThis, null, _containerAnchor_decorators, { kind: "accessor", name: "containerAnchor", static: false, private: false, access: { has: obj => "containerAnchor" in obj, get: obj => obj.containerAnchor, set: (obj, value) => { obj.containerAnchor = value; } }, metadata: _metadata }, _containerAnchor_initializers, _containerAnchor_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTh = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTh = _classThis;
})();
export { SdsTh };
